/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EventIcon = ({ width = 24, height = 24, hidden = false, title = 'Event' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.5 10.054a.494.494 0 0 0-.5.5v24.782a.494.494 0 0 0 .846.354L26.51 28h9c.445 0 .479-.726.225-.98L18.846 10.2a.489.489 0 0 0-.346-.146Z"
    />
    <path d="M13.991 30H5.997V6H30v8l4 4V2H2v32h11.991v-4z" />
  </svg>`;
};
